/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { DeleteVideoEditorEditsEditMutationResponse, DeleteVideoEditorEditsEditPathParams } from "../models/DeleteVideoEditorEditsEdit";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { deleteVideoEditorEditsEdit } from "../axios/deleteVideoEditorEditsEdit";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteVideoEditorEditsEditMutationKey = () => ["web-app-bff-api", { url: '/video-editor/edits/:id' }] as const

export type DeleteVideoEditorEditsEditMutationKey = ReturnType<typeof deleteVideoEditorEditsEditMutationKey>

export function deleteVideoEditorEditsEditMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteVideoEditorEditsEditMutationKey()
        return mutationOptions<DeleteVideoEditorEditsEditMutationResponse, ResponseErrorConfig<Error>, {id: DeleteVideoEditorEditsEditPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return deleteVideoEditorEditsEdit(id, config)
          },
        })

}

/**
 * @summary Delete an edit
 * {@link /video-editor/edits/:id}
 */
export function useDeleteVideoEditorEditsEdit<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteVideoEditorEditsEditMutationResponse, ResponseErrorConfig<Error>, {id: DeleteVideoEditorEditsEditPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteVideoEditorEditsEditMutationKey()

          const baseOptions = deleteVideoEditorEditsEditMutationOptions(config) as UseMutationOptions<DeleteVideoEditorEditsEditMutationResponse, ResponseErrorConfig<Error>, {id: DeleteVideoEditorEditsEditPathParams["id"]}, TContext>
          

          return useMutation<DeleteVideoEditorEditsEditMutationResponse, ResponseErrorConfig<Error>, {id: DeleteVideoEditorEditsEditPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteVideoEditorEditsEditMutationResponse, ResponseErrorConfig<Error>, {id: DeleteVideoEditorEditsEditPathParams["id"]}, TContext>
      
}